import { hc_utils } from './_utils.js';

export let hc_templates = {};

/*
----------------------------
Module - Templates
----------------------------
*/

hc_templates.notifiers = {
    'general': {
        'record_error': `
            <div class="alert alert-danger" role="alert">
                <h2>Sorry</h2> 
                <p>We are having trouble locating your record.</p>
                <p>Please call Hutt City Council on 04 570 6666 for further details.</p>
            </div>
        `,
        'updated_details_success': `
            <div class="alert alert-info" role="alert">
                <h2>Thank you</h2> 
                <p>The changes to your details have been received.</p>
                <p>Please call Hutt City Council on 04 570 6666 for further details.</p>
            </div>
        `
    },
    'error': {
        'fines_lookup': `
            <div class="alert alert-danger" role="alert">
                <h2>Sorry</h2> 
                <p>This infringement is <strong>not available</strong> for payment online, for one of the following reasons:</p>
                <ul class="">
                    <li><span>You have not entered the infringement number correctly</span></li>
                    <li><span>If you are paying your dog infringement, check the infringement number matches the dog number</span></li>
                    <li><span>It has been issued within the past 24 hours and has yet to be loaded into the system</span></li>
                    <li><span>It has already been paid</span></li>
                    <li><span>It has been waived or cancelled</span></li>
                    <li><span>The time period for payment (as specified on the reminder notice) has passed, and the infringement has now been referred to the Ministry Of Justice for collection.</span></li>
                </ul>
                <p><strong>Any queries please call Hutt City Council <br> 
                on 04 570 6666</strong></p>
            </div>
        `
    }
};


// Template for fines payment summaries
hc_templates.fines = function(data, type) {
    if(!data){
        throw new Error("No data");
    }
    // the price will change if the Due date is in the past
    let priceOutput = hc_utils.cleanPrice(data.Amount);
    let dateIsInThePast = hc_utils.dateIsInThePast(data.Due_Date);
    if(dateIsInThePast){
        priceOutput = hc_utils.cleanPrice(data.Amount);
    }

    let output = [];
    let status = data.progressStatusId;
    let statusDesc = status === 36 ? "Paid" : "Unpaid";
    let alertTypeClass = 'alert-warning';
    if(status == 36){
        alertTypeClass = 'alert-info';
    }
    let dueDate = hc_utils.cleanDate(data.Due_Date);
    let fineDate = hc_utils.cleanDate(data.Infringement_Date);
    let fineTime = hc_utils.cleanTime(data.Infringement_Time);

    output.push(`<form action="#"><div>
        <div class="alert ${alertTypeClass} status-${status}" role="alert">
            <h1>${status == 36 ? `Paid` : `Amount due: ${priceOutput} ${dueDate != '' ? `by <small>${dueDate}</small>` : ``} `}</h1>
        </div>
        <h2>Infringement details</h2>
    `);
    output.push(`<div>
        <ul>
            <li><strong>Infringement number:</strong> ${data.Infringement_No}</li>
            <li><strong>Due date:</strong> ${dueDate}</li>
            <li><strong>${data.Infringement_Type == 'PT' ? `Car registration` : 'Reference number'}: </strong>${data.Reference_No}</li>
            <li><strong>Amount:</strong> ${priceOutput}</li>
            <li><strong>Status:</strong> ${statusDesc}</li>
            <li><strong>Location:</strong> ${data.Infringement_Location}</li>
            <li><strong>Date:</strong> ${fineDate}</li>
            <li><strong>Time:</strong> ${fineTime}</li>
        </ul>
    `);
    
    if(type == 'parking'){

    } else if(type == 'dog'){
        
    } else if(type == 'litter'){
        
    } else if(type == 'noise'){

    } else if(type == 'resource_management'){
        
    }

    output.push(`</div></form>`);
    
    return output.join('');
};

// Template for animal renewal payment summary
hc_templates.animals2 = function(data, type) {
    if(!data){
        throw new Error("No data");
    }
    let output = [];
    let status = data.progressStatusId;
    let statusDesc = status === 36 ? "Paid" : "Unpaid";
    let alertTypeClass = 'alert-warning';
    if(status == 36){
        alertTypeClass = 'alert-info';
    }
    output.push(`<form action="#"><div>
        <div class="alert ${alertTypeClass} status-${status}" role="alert">
            <h1>${status == 36 ? `Paid` : `Amount due: ${hc_utils.cleanPrice(data.Amount_Due)} by <small>${hc_utils.cleanDate(data.Due_Date)}</small>`}</h1>
        </div>
        <h2>Dog registration renewal</h2>
    `);
    output.push(`<div>
        <ul>
            <li><strong>Dog ID:</strong> ${data.Animal_Id}</li>
            <li><strong>Dog Owner ID (Person ID):</strong> ${data.Person_Id}</li>
            <li><strong>The Dogs physical address:</strong> ${data.Animal_Location}</li>
            
            <li><strong>Due date:</strong> ${hc_utils.cleanDate(data.Due_Date)}</li>

            <li><strong>Amount:</strong> ${hc_utils.cleanPrice(data.Amount_Due)}</li>
            <li><strong>Status:</strong> ${statusDesc}</li>

        </ul>
    `);

    output.push(`
        <div class="sq-form-question sq-form-question-tickbox-list">
            <fieldset>
            <legend class="sq-form-section-title">Confirmation</legend>

                <div class="sq-form-question-answer">
                    <ul>
                        <li>
                            <input type="checkbox" value="Opted to receive invoice by email" name="opt_email" id="opt_email" class="" />
                            <label for="opt_email" class="sq-form-section-title">If you would like to receive your invoice by email in future, please ensure your email address is up to date and tick this box.</label>
                        </li>
                        <li>
                            <input type="checkbox" value="Confirmed owner" name="opt_owner" id="opt_owner" class="" required />
                            <label for="opt_owner" class="sq-form-section-title">
                                I confirm that I am the named owner of this dog and the details provided are true and correct. <br />
                                I have read and accept the <a href="http://www.huttcity.govt.nz/Get-in-touch-with-us/About-this-website/Terms-and-conditions/" target="_blank" class="opt_links">Terms and Conditions</a>
                            </label>
                        </li>
                    </ul>
                </div>

            </fieldset>
        </div>
    `);
    output.push(`<input type="submit" value="Submit" name="submit-form" class="d-none">`);
    output.push(`</div></form>`);
    
    return output.join('');
};


// Template for animal renewal payment summary
hc_templates.animals = function(data, type) {
    if(!data){
        throw new Error("No data");
    }
    // the price will change if the Due date is in the past
    let priceOutput = hc_utils.cleanPrice(data.Amount_Due);
    let dateIsInThePast = hc_utils.dateIsInThePast(data.Due_Date);
    if(dateIsInThePast){
        priceOutput = hc_utils.cleanPrice(data.Amount_Due_Cutoff);
    }

    let output = [];

    let status = data.progressStatusId;
    if(status == 36){
        output.push(`
            <div class="alert alert-info status-36" role="alert">
                <h1>Paid</h1>
            </div>`);
    }

    output.push(`<form id="ds_details_form" action="${hccosp.vars.proxy}">`);
    output.push(`
    <fieldset>
        <legend class="sq-form-section-title">Owner details</legend>

        <input type="hidden" id="changed-fields" name="changed-fields">

        <div class="sq-form-question sq-form-question-text">
            <label for="Person_Id" class="sq-form-section-title">Person ID</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Person_Id != 'undefined' ? `${data.Person_Id}`: ``}" name="Person_Id" id="Person_Id" class="sq-form-field" readonly />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Home_Phone" class="sq-form-section-title">Owner's phone (home)</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Home_Phone != 'undefined' ? `${data.Owner_Home_Phone}`: ``}" name="Owner_Home_Phone" id="Owner_Home_Phone" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Work_Phone" class="sq-form-section-title">Owner's phone (work)</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Work_Phone != 'undefined' ? `${data.Owner_Work_Phone}`: ``}" name="Owner_Work_Phone" id="Owner_Work_Phone" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Mobile_Phone" class="sq-form-section-title">Owner's phone (mobile)</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Mobile_Phone != 'undefined' ? `${data.Owner_Mobile_Phone}`: ``}" name="Owner_Mobile_Phone" id="Owner_Mobile_Phone" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_DOB" class="sq-form-section-title">Owner's date of birth
                <abbr class="sq-form-required-field" title="required">*</abbr>
            </label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_DOB != 'undefined' ? `${hc_utils.cleanDate(data.Owner_DOB)}`: ``}" name="Owner_DOB" id="Owner_DOB" class="sq-form-field" required />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Address_Line_1" class="sq-form-section-title">Postal address line 1</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Address_Line_1 != 'undefined' ? `${data.Owner_Address_Line_1}`: ``}" name="Owner_Address_Line_1" id="Owner_Address_Line_1" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Address_Line_2"class="sq-form-section-title">Postal address line 2</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Address_Line_2 != 'undefined' ? `${data.Owner_Address_Line_2}`: ``}" name="Owner_Address_Line_2" id="Owner_Address_Line_2" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Address_Line_3" class="sq-form-section-title">Postal address line 3</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Address_Line_3 != 'undefined' ? `${data.Owner_Address_Line_3}`: ``}" name="Owner_Address_Line_3" id="Owner_Address_Line_3" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Address_Line_4" class="sq-form-section-title">Postal address line 4</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Address_Line_4 != 'undefined' ? `${data.Owner_Address_Line_4}`: ``}" name="Owner_Address_Line_4" id="Owner_Address_Line_4" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Owner_Address_Line_5" class="sq-form-section-title">Postal address line 5</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Owner_Address_Line_5 != 'undefined' ? `${data.Owner_Address_Line_5}`: ``}" name="Owner_Address_Line_5" id="Owner_Address_Line_5" class="sq-form-field" />
            </div>
        </div>

        <div class="sq-form-question sq-form-question-text">
            <label for="Email_Address" class="sq-form-section-title">Email</label>
            <div class="sq-form-question-answer">
                <input type="text" value="${data.Email_Address != 'undefined' ? `${data.Email_Address}`: ``}" name="Email_Address" id="Email_Address" class="sq-form-field" />
            </div>
        </div>

    </fieldset>


    `);
    

    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">${data.Animal_Name != 'undefined' ? `${data.Animal_Name}`: ``}</legend>
            
            <div class="sq-form-question sq-form-question-tickbox-list">
				<fieldset>
					<legend class="sq-form-question-title">Renewal of registration</legend>
					<div class="sq-form-question-answer">
						<ul>
							<li>
                                <input type="checkbox" value="renew_yes" name="opt_renewal" id="opt_renewal" class="sq-form-field" checked="checked" /> 
                                <label for="opt_renewal" class="sq-form-section-title">I wish to renew this dog's registration today.</label>
                            </li>
						</ul>
					</div>
				</fieldset>
			</div>


            <div class="sq-form-question sq-form-question-text">
                <label for="Amount_Due" class="sq-form-section-title">Amount due (inc GST)</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${priceOutput}" name="Amount_Due" id="Amount_Due" class="sq-form-field" readonly />
                </div>
            </div>
            
            <div class="sq-form-question sq-form-question-text">
                <label for="Due_Date" class="sq-form-section-title">Payment due date</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${hc_utils.cleanDate(data.Due_Date)}" name="Due_Date" id="Due_Date" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Animal_Id" class="sq-form-section-title">Dog ID</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Animal_Id}" name="Animal_Id" id="Animal_Id" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Licence_No" class="sq-form-section-title">One Tag</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Licence_No}" name="Licence_No" id="Licence_No" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Animal_RDO_Status" class="sq-form-section-title">RDO status</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Animal_RDO_Status == 0 ? `No` : `Yes`}" name="Animal_RDO_Status" id="Animal_RDO_Status" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Animal_Location" class="sq-form-section-title">Physical address of dog
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Animal_Location" id="Animal_Location" class="sq-form-field" required>${data.Animal_Location != 'undefined' ? `${data.Animal_Location}`: ``}</textarea>
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Animal_Name" class="sq-form-section-title">Name of dog</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Animal_Name != 'undefined' ? `${data.Animal_Name}`: ``}" name="Animal_Name" id="Animal_Name" class="sq-form-field" />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Animal_Microchip_No" class="sq-form-section-title">Microchip number</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Animal_Microchip_No != 'undefined' ? `${data.Animal_Microchip_No}`: ``}" name="Animal_Microchip_No" id="Animal_Microchip_No" class="sq-form-field" />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Primary_Breed" class="sq-form-section-title">Breed (primary)</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Primary_Breed != 'undefined' ? `${data.Primary_Breed}`: ``}" name="Primary_Breed" id="Primary_Breed" class="sq-form-field" />
                <div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Secondary_Breed" class="sq-form-section-title">Breed (secondary)</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Secondary_Breed != 'undefined' ? `${data.Secondary_Breed}`: ``}" name="Secondary_Breed" id="Secondary_Breed" class="sq-form-field" />
                <div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Primary_Colour" class="sq-form-section-title">Colour (primary)</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Primary_Colour != 'undefined' ? `${data.Primary_Colour}`: ``}" name="Primary_Colour" id="Primary_Colour" class="sq-form-field" />
                <div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Secondary_Colour" class="sq-form-section-title">Colour (secondary)</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Secondary_Colour != 'undefined' ? `${data.Secondary_Colour}`: ``}" name="Secondary_Colour" id="Secondary_Colour" class="sq-form-field" />
                <div>
            </div>

        </fieldset>
        
    `);

    output.push(`
        <div class="sq-form-question sq-form-question-tickbox-list">
            <fieldset>
            <legend class="sq-form-section-title">Confirmation</legend>

                <div class="sq-form-question-answer">
                    <ul>
                        <li>
                            <input type="checkbox" value="Opted to receive invoice by email" name="opt_email" id="opt_email" class="" />
                            <label for="opt_email" class="sq-form-section-title">If you would like to receive your invoice by email in future, please ensure your email address is up to date and tick this box.</label>
                        </li>
                        <li>
                            <input type="checkbox" value="Confirmed owner" name="opt_owner" id="opt_owner" class="" required />
                            <label for="opt_owner" class="sq-form-section-title">
                                I confirm that I am the named owner of this dog and the details provided are true and correct. <br />
                                I have read and accept the <a href="http://www.huttcity.govt.nz/Get-in-touch-with-us/About-this-website/Terms-and-conditions/" target="_blank" class="opt_links">Terms and Conditions</a>
                            </label>
                        </li>
                    </ul>
                </div>

            </fieldset>
        </div>
    `);

    
    output.push(`<input type="submit" value="Submit" name="submit-form" class="d-none">`);
    output.push(`</form>`);
    
    return output.join('');
}

// Template for health renewal payment summary
hc_templates.health = function(data, type) {
    if(!data){
        throw new Error("No data");
    }
    
    let output = [];

    let status = data.progressStatusId;
    if(status == 36){
        output.push(`
            <div class="alert alert-info status-36" role="alert">
                <h1>Paid</h1>
            </div>`);
    }

    output.push(`<form id="ds_details_form" action="${hccosp.vars.proxy}">`);

    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">Invoice details</legend>

            <input type="hidden" id="changed-fields" name="changed-fields">

            <div class="sq-form-question sq-form-question-text">
                <label for="Invoice_No" class="sq-form-section-title">Invoice number</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Invoice_No}" name="Invoice_No" id="Invoice_No" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Amount_Due" class="sq-form-section-title">Amount due</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${hc_utils.cleanPrice(data.Amount_Due)}" name="Amount_Due" id="Amount_Due" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Payment_Due_Date" class="sq-form-section-title">Payment due date</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${hc_utils.cleanDate(data.Payment_Due_Date)}" name="Payment_Due_Date" id="Payment_Due_Date" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Payment_Status" class="sq-form-section-title">Payment status</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="Unpaid" name="Payment_Status" id="Payment_Status" class="sq-form-field" readonly />
                </div>
            </div>

        </fieldset>
    `);


    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">Applicant's details</legend>

            <div class="sq-form-question sq-form-question-text">
                <label for="Application_No" class="sq-form-section-title">Registration number</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Application_No}" name="Application_No" id="Application_No" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Applicant_Company" class="sq-form-section-title">Applicant/company
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Applicant_Company}" name="Applicant_Company" id="Applicant_Company" class="sq-form-field" required />
                <div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Postal_Address" class="sq-form-section-title">Postal address
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Postal_Address" id="Postal_Address" class="sq-form-field" required>${data.Postal_Address}</textarea>
                </div>
            </div>

        </fieldset>
    `);

    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">Business details</legend>
            
            <div class="sq-form-question sq-form-question-text">
                <label for="Trading_Name" class="sq-form-section-title">Business name
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Trading_Name}" name="Trading_Name" id="Trading_Name" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Business_Address" class="sq-form-section-title">Business address
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Business_Address" id="Business_Address" class="sq-form-field" required>${data.Business_Address}</textarea>
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Applicant_Phone_No" class="sq-form-section-title">Telephone
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Applicant_Phone_No}" name="Applicant_Phone_No" id="Applicant_Phone_No" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Fax" class="sq-form-section-title">Fax</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Fax}" name="Fax" id="Fax" class="sq-form-field" />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Business_Email" class="sq-form-section-title">Email
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Business_Email}" name="Business_Email" id="Business_Email" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Authorised_Contact_Name" class="sq-form-section-title">Name of authorised contact
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Authorised_Contact_Name}" name="Authorised_Contact_Name" id="Authorised_Contact_Name" class="sq-form-field" />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Authorised_Contact_Position" class="sq-form-section-title">Job title of authorised contact
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Authorised_Contact_Position}" name="Authorised_Contact_Position" id="Authorised_Contact_Position" class="sq-form-field" />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="License_Type" class="sq-form-section-title">Registration type</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.License_Type}" name="License_Type" id="License_Type" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="License_Category" class="sq-form-section-title">Category</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.License_Category}" name="License_Category" id="License_Category" class="sq-form-field" />
                </div>
            </div>
            <div class="sq-form-question sq-form-question-text">
                <label for="Sub_Category" class="sq-form-section-title">Sub category</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Sub_Category}" name="Sub_Category" id="Sub_Category" class="sq-form-field" />
                </div>
            </div>

        </fieldset>
    `);

    output.push(`
        <div class="sq-form-question sq-form-question-option-list">
        <fieldset>
            <legend class="sq-form-section-title">Is this a transfer of a current registration?</legend>

            <div class="sq-form-question-answer">
                <ul>
                    <li>
                        <input type="radio" value="transfer_reg_yes" name="transfer_reg" id="transfer_reg_yes" class="" />
                        <label for="transfer_reg_yes" class="sq-form-section-title">Yes</label>
                    </li>
                    <li>
                        <input type="radio" value="transfer_reg_no" name="transfer_reg" id="transfer_reg_no" class="" checked />
                        <label for="transfer_reg_no" class="sq-form-section-title">No</label>
                    </li>
                </ul>
            </div>

        </fieldset>
    `);

    output.push(`
        <div class="sq-form-question sq-form-question-tickbox-list">
            <fieldset>
            <legend class="sq-form-section-title">Confirmation <abbr class="sq-form-required-field" title="required">*</abbr></legend>

                <div class="sq-form-question-answer">
                    <ul>
                        <li>
                            <input type="checkbox" value="Confirmed" name="opt_confirmation" id="opt_confirmation" class="" required />
                            <label for="opt_confirmation" class="sq-form-section-title">
                                I confirm that the details above are correct and that I have read and agree with the <a href="http://www.huttcity.govt.nz/Get-in-touch-with-us/About-this-website/Terms-and-conditions/" target="_blank" class="opt_links">Terms and Conditions</a>
                            </label>
                        </li>
                        
                    </ul>
                </div>

            </fieldset>
        </div>
    `);

    output.push(`<input type="submit" value="Submit" name="submit-form" class="d-none"> </form>`);
    
    return output.join('');
}


// Template for trade waste renewal payment summary
hc_templates.tradewaste = function(data, type) {
    if(!data){
        throw new Error("No data");
    }
    let output = [];

    let status = data.progressStatusId;
    if(status == 36){
        output.push(`
            <div class="alert alert-info status-36" role="alert">
                <h1>Paid</h1>
            </div>`);
    }

    output.push(`<form id="ds_details_form" action="${hccosp.vars.proxy}">`);

    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">Invoice details</legend>

            <input type="hidden" id="changed-fields" name="changed-fields">

            <div class="sq-form-question sq-form-question-text">
                <label for="Invoice_No" class="sq-form-section-title">Invoice number</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Invoice_No}" name="Invoice_No" id="Invoice_No" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Amount_Due" class="sq-form-section-title">Amount due</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${hc_utils.cleanPrice(data.Amount_Due)}" name="Amount_Due" id="Amount_Due" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Payment_Due_Date" class="sq-form-section-title">Payment due date</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${hc_utils.cleanDate(data.Payment_Due_Date)}" name="Payment_Due_Date" id="Payment_Due_Date" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Payment_Status" class="sq-form-section-title">Payment status</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="Unpaid" name="Payment_Status" id="Payment_Status" class="sq-form-field" readonly />
                </div>
            </div>

        </fieldset>
    `);


    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">Applicant's details</legend>

            <div class="sq-form-question sq-form-question-text">
                <label for="Application_Number" class="sq-form-section-title">TRA number</label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Application_Number}" name="Application_Number" id="Application_Number" class="sq-form-field" readonly />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Applicant_Company" class="sq-form-section-title">Applicant/company
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Applicant_Company}" name="Applicant_Company" id="Applicant_Company" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Registered_Address" class="sq-form-section-title">Registered address
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Registered_Address" id="Registered_Address" class="sq-form-field" required>${data.Registered_Address}</textarea>
                </div>
            </div>
            <div class="sq-form-question sq-form-question-text">
                <label for="Postal_Address" class="sq-form-section-title">Postal address
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Postal_Address" id="Postal_Address" class="sq-form-field" required>${data.Postal_Address}</textarea>
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Applicant_Phone_No" class="sq-form-section-title">Telephone
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Applicant_Phone_No}" name="Applicant_Phone_No" id="Applicant_Phone_No" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Emails_Other" class="sq-form-section-title">Email
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Emails_Other}" name="Emails_Other" id="Emails_Other" class="sq-form-field" required />
                </div>
            </div>

        </fieldset>
    `);

    output.push(`
        <fieldset>
            <legend class="sq-form-section-title">Business details</legend>
            
            <div class="sq-form-question sq-form-question-text">
                <label for="Premises_Known_As" class="sq-form-section-title">Business name
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Premises_Known_As}" name="Premises_Known_As" id="Premises_Known_As" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Main_Trade_Activity" class="sq-form-section-title">Description of business
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Main_Trade_Activity" id="Main_Trade_Activity" class="sq-form-field" required>${data.Main_Trade_Activity}</textarea>
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Situated_At" class="sq-form-section-title">Business address
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <textarea name="Situated_At" id="Situated_At" class="sq-form-field" required>${data.Situated_At}</textarea>
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Premises_Phone_No" class="sq-form-section-title">Telephone
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Premises_Phone_No}" name="Premises_Phone_No" id="Premises_Phone_No" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Business_Email_Other" class="sq-form-section-title">Email
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Business_Email_Other}" name="Business_Email_Other" id="Business_Email_Other" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Contact" class="sq-form-section-title">Name of authorised contact
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Contact}" name="Contact" id="Contact" class="sq-form-field" required />
                </div>
            </div>

            <div class="sq-form-question sq-form-question-text">
                <label for="Position" class="sq-form-section-title">Job title of authorised contact
                    <abbr class="sq-form-required-field" title="required">*</abbr>
                </label>
                <div class="sq-form-question-answer">
                    <input type="text" value="${data.Position}" name="Position" id="Position" class="sq-form-field" required />
                </div>
            </div>

        </fieldset>
    `);

    output.push(`
        <div class="sq-form-question sq-form-question-option-list">
        <fieldset>
            <legend class="sq-form-section-title">Is this a transfer of a current registration?</legend>

            <div class="sq-form-question-answer">
                <ul>
                    <li>
                        <input type="radio" value="transfer_reg_yes" name="transfer_reg" id="transfer_reg_yes" class="" />
                        <label for="transfer_reg_yes" class="sq-form-section-title">Yes</label>
                    </li>
                    <li>
                        <input type="radio" value="transfer_reg_no" name="transfer_reg" id="transfer_reg_no" class="" checked />
                        <label for="transfer_reg_no" class="sq-form-section-title">No</label>
                    </li>
                </ul>
            </div>

        </fieldset>
    `);

    output.push(`
        <div class="sq-form-question sq-form-question-tickbox-list">
            <fieldset>
            <legend class="sq-form-section-title">Confirmation <abbr class="sq-form-required-field" title="required">*</abbr></legend>

                <div class="sq-form-question-answer">
                    <ul>
                        <li>
                            <input type="checkbox" value="Confirmed" name="opt_confirmation" id="opt_confirmation" class="" required />
                            <label for="opt_confirmation" class="sq-form-section-title">
                                I confirm that the details above are correct and that I have read and agree with the <a href="http://www.huttcity.govt.nz/Get-in-touch-with-us/About-this-website/Terms-and-conditions/" target="_blank" class="opt_links">HCC Terms and Conditions</a>
                            </label>
                        </li>
                        
                    </ul>
                </div>

            </fieldset>
        </div>
    `);

    output.push(`<input type="submit" value="Submit" name="submit-form" class="d-none"> </form>`);
    
    return output.join('');
}
